export const AUTH = 'auth'
export const BINANCE_NATIVE = 'binance-native'
export const BINANCE = 'binance'
export const BINANCE_DEALS = 'binance-deals'
export const BINANCE_SYMBOLS = 'binance-symbols'
export const ACCOUNT = 'account'
export const RITHMIC = 'rithmic'
export const RITHMIC_DEALS = 'rithmic-deals'
export const RITHMIC_SYMBOLS = 'rithmic-symbols'
export const BYBIT_NATIVE = 'bybit-native'
export const BYBIT = 'bybit'
export const BYBIT_SYMBOLS = 'bybit-symbols'
export const BYBIT_DEALS = 'bybit-deals'
export const BITGET_NATIVE = 'bitget-native'
export const BITGET = 'bitget'
export const BITGET_SYMBOLS = 'bitget-symbols'
export const BITGET_DEALS = 'bitget-deals'
export const OKX_NATIVE = 'okx-native'
export const OKX = 'okx'
export const OKX_SYMBOLS = 'okx-symbols'
export const OKX_DEALS = 'okx-deals'
export const STAKING = 'staking'
export const REFERRAL = 'referral'
export const PARTNER = 'partner'
export const PUSH = 'push'
export const ARCHITECTURE = 'architecture'
export const BOOK = 'book'
export const TT = 'tt'
export const TT_DEALS = 'tt-deals'
export const TT_SYMBOLS = 'tt-symbols'
export const CQG = 'cqg'
export const CQG_DEALS = 'cqg-deals'
export const CQG_SYMBOLS = 'cqg-symbols'

export const COMMENTS = 'comments'
export const PUBLIC_REPORT = 'public-report'
